import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

type BasketItemContext = {
  activeBasket: string | undefined;
  setActiveBasket: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const Context = createContext<BasketItemContext>({
  activeBasket: undefined,
  setActiveBasket: () => null,
});

type BasketItemContextProps = PropsWithChildren & {
  activeBasket: string | undefined;
  setActiveBasket: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const BasketItemContext = ({
  children,
  activeBasket,
  setActiveBasket,
}: BasketItemContextProps) => {
  const values = useMemo(
    () => ({
      activeBasket,
      setActiveBasket,
    }),
    [activeBasket, setActiveBasket],
  );

  return <Context.Provider value={values}>{children}</Context.Provider>;
};

export const useBasketItemContext = () => useContext(Context);
